import React from "react";
import { useDispatch } from "react-redux";
import { Field, Form, Formik } from "formik";
import * as i18nUtils from "util/i18n";
import { actions as adheredServicesActions } from "reducers/afipPaymentLink";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { Col, Row } from "react-bootstrap";
import Container from "pages/_components/Container";

const FORM_ID = "linkedservice.edit";

const EditService = ({ service, setDrawer }) => {
    const dispatch = useDispatch();
    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            alias:  service.alias || '',
        },
        onSubmit: (values) => {
            if (values) {
                dispatch(adheredServicesActions.editAdheredService(service.adhesionCode, values.alias.trim()));
                setDrawer({
                    showDrawer: false,
                    contentDrawer: null,
                });   
            }
        },
    };

    return (
        <div className="container">
        <h2 className="title-content text-center">
            <I18n id={`${FORM_ID}.drawertitle`} />
        </h2>
        <div className="row">
         <Formik {...formikProps}>
        {() => (
            <Form className="above-the-fold">
                <Container className="container--layout flex-grow">
                    <Row className="gap-8">
                        <Col sm={12} md={8} mdOffset={2} className="form-group form-group--select">
                            <Field
                                autoComplete="off"
                                component={TextField}
                                idForm={FORM_ID}
                                maxLength={25}
                                name="alias"
                                labelTextDefault={i18nUtils.get(`${FORM_ID}.alias`)}
                                hidePlaceholder
                            />
                        </Col>
                        <Col sm={12} md={8} mdOffset={2}>
                            <Button type="submit" bsStyle="primary" label="linkedservice.edit.action" loading={false} block />
                        </Col>
                    </Row>
                </Container>
            </Form>
             )}
        </Formik>
        </div>
    </div>
    );
};

EditService.propTypes = {
};

EditService.defaultProps = {};

export default EditService;
